<template>
  <kbd
    v-bind="$attrs"
    class="rounded border border-gray-400 bg-gray-100 px-1.5 py-0.5 text-xs font-semibold text-gray-700 hover:text-primary-700"
  >
    <slot />
  </kbd>
</template>
